// Webpack Imports
import * as bootstrap from 'bootstrap';

// import ingredientPane from './modules/ingredientPane';
import print from './modules/print';
import share from './modules/share';
import filters from './modules/filters';
import modal from './modules/modal';

( function () {
	'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    // pop ingredients on mobile when scrolling past them
    // ingredientPane();

    // print on click
    print();

    // inject Add2Any share script when needed
    share();

    // search filter and category filter
    filters();

    // modal
    modal();
  });
} )();